import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Benefit } from '../Benefit';
import { useFeatureUsage } from '../../store/featureUsageStore';

const i18n = defineMessages({
	standardFeatureUserLimitTitle: {
		id: 'end-of-trial-payment-modals.standard.feature.user-limit.title',
		defaultMessage: 'Unlimited user limit',
		description: 'Unlimited user limit title',
	},
	standardFeatureUserLimitSubtitle: {
		id: 'end-of-trial-payment-modals.standard.feature.user-limit.subtitle',
		defaultMessage: 'Get everyone on the same tool.',
		description: 'Unlimited user limit subtitle',
	},
});

export const UnlimitedUsers = () => {
	const intl = useIntl();

	const { numberOfUsers } = useFeatureUsage();

	return (
		<Benefit
			benefit={intl.formatMessage(i18n.standardFeatureUserLimitTitle)}
			explanation={intl.formatMessage(i18n.standardFeatureUserLimitSubtitle)}
			benefitTitle="unlimited-users"
			usingBenefit={!!numberOfUsers && numberOfUsers > 10}
		/>
	);
};
